// ============================================
// Creator Editor - Modal Module (ES6)
// 타입 선택, 에디터 열기/닫기
// ============================================

import { showToast } from '../../utils.js';
import { getCurrentCreations, getCurrentEditorData, resetEditorData } from '../state.js';
import { loadCreationForEdit, resetEditorForm, updateAutoFillFabVisibility } from './form.js';
import { switchEditorTab, bindEditorEvents, updateImageGenButtonState } from './events.js';
import { openCreationMethodModal, bindWizardEvents } from '../wizard/index.js';
import { initCustomDesc, initCreatorComment } from './custom-desc.js';

// ============================================
// 타입 선택 모달
// ============================================

export function openCreationTypeModal() {
  const modal = document.getElementById('creationTypeModal');
  if (!modal) return;

  modal.style.display = 'flex';
  modal.offsetHeight;
  modal.classList.add('active');
  if (window.ModalManager) {
    window.ModalManager.push('creationTypeModal');
  }
}

export function closeCreationTypeModal() {
  const modal = document.getElementById('creationTypeModal');
  if (!modal) return;

  modal.classList.remove('active');
  setTimeout(() => {
    if (!modal.classList.contains('active')) {
      modal.style.display = 'none';
    }
  }, 300);

  if (window.ModalManager) {
    window.ModalManager.remove('creationTypeModal', true);
  }
}

export function selectCreationType(type) {
  closeCreationTypeModal();

  if (type === 'character') {
    openCharacterEditor(null);
  } else if (type === 'story') {
    if (window.StoryCreatorModule && typeof window.StoryCreatorModule.openEditor === 'function') {
      window.StoryCreatorModule.openEditor(null);
    } else {
      showToast('스토리 모드 준비 중입니다');
    }
  }
}

// ============================================
// 에디터 열기/닫기
// ============================================

export async function openEditor(creationId = null) {
  // 새 캐릭터 생성: 빠른 시작 vs 직접 만들기 선택 모달
  if (!creationId) {
    // 마법사 이벤트 바인딩 (최초 1회)
    bindWizardEvents();
    openCreationMethodModal();
    return;
  }

  const creation = getCurrentCreations().find(c => c.id === creationId);
  if (creation && creation.type === 'story') {
    showToast('스토리 모드는 준비 중입니다');
  } else {
    await openCharacterEditor(creationId);
  }
}

export async function openCharacterEditor(creationId = null) {
  const modal = document.getElementById('characterEditorModal');
  if (!modal) return;

  // 상태 초기화
  resetEditorData();
  getCurrentEditorData().id = creationId;

  // 폼 초기화
  resetEditorForm();

  // 기존 제작물 편집인 경우 데이터 로드
  if (creationId) {
    await loadCreationForEdit(creationId);
  } else {
    updateAutoFillFabVisibility();
  }

  // 모달 슬라이드 표시
  modal.style.display = 'flex';
  document.body.style.overflow = 'hidden';
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      modal.classList.add('active');
      if (window.ModalManager) {
        window.ModalManager.push('characterEditorModal');
      }
    });
  });

  // 첫 번째 탭으로 전환
  switchEditorTab('info');

  // 스크롤을 상단으로 이동
  const editorContent = modal.querySelector('.editor-content');
  if (editorContent) {
    editorContent.scrollTop = 0;
  }

  // 입력 이벤트 바인딩
  bindEditorEvents();

  // 커스텀 설명 에디터 초기화
  initCustomDesc();

  // 제작자 코멘트 에디터 초기화
  initCreatorComment();

  // 이미지 생성 버튼 상태 초기화
  updateImageGenButtonState();
}

export function closeEditor() {
  const modal = document.getElementById('characterEditorModal');
  if (modal) {
    modal.classList.remove('active');
    document.body.style.overflow = '';
    setTimeout(() => {
      if (!modal.classList.contains('active')) {
        modal.style.display = 'none';
      }
    }, 300);
  }
  if (window.ModalManager) {
    window.ModalManager.remove('characterEditorModal', true);
  }
}
